import { PermissionContext } from "providers/permissions"
import { useContext } from "react"
import { Navigate } from "react-router-dom"

type Props = {
  to: string | string[]
  type: "permissions" | "groups" | "modules" | "services"
}

const RequirePermission: React.FC<Props> = ({ to, type, children }) => {
  const { isAllowedTo } = useContext(PermissionContext)
  if (isAllowedTo(to, type)) {
    return <>{children}</>
  }

  return (
    <Navigate
      replace
      to={{
        pathname: "/permission-error",
      }}
    />
  )
}

export default RequirePermission
